import { Model } from './model.class'
import { TTerraceWidth } from '../../utility/type/terraceCover.type'

/**
 * A class for model chata
 */
export abstract class Chata extends Model {
  /**
   * Returns number of windows
   * @param width Width of the terrace
   * @returns number of windows needed
   */
  public static windowsTop(width: TTerraceWidth): number {
    return width / 100 + (width === 200 ? 1 : 0)
  }
}
